// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyADklsdoD6ZIZifinoNlRm9ProVXH6WVmE",
  authDomain: "altagraciarugby-agr.firebaseapp.com",
  databaseURL: "https://altagraciarugby-agr.firebaseio.com",
  projectId: "altagraciarugby-agr",
  storageBucket: "altagraciarugby-agr.appspot.com",
  messagingSenderId: "717883290520",
  appId: "1:717883290520:web:5410035538a164f13d71ed",
  measurementId: "G-KWT0DJXBZW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const authApp = getAuth(app);
authApp.languageCode = 'es';

export const
  db = getFirestore(app),
  rtdb = getDatabase(app),
  storage = getStorage(app),
  auth = authApp;

